import * as React from "react";
import IFIX from "./Images/IFIX GREEN.png";

function Footer() {
  return (
    <div className="flex flex-col items-center px-20 pt-6 pb-6 bg-teal-50 rounded-md shadow-2xl max-md:px-5">
      <div className="max-w-full w-[978px]">
        <div className="flex gap-5 max-md:flex-col max-md:gap-0">
          <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow items-start text-sm font-medium tracking-wider leading-6 text-justify capitalize text-neutral-600 max-md:mt-10 max-md:max-w-full">
              <img
                loading="lazy"
                src={IFIX}
                className="max-w-full w-[20%] h-[30%]"
              />
              <div className="self-stretch mt-7 max-md:max-w-full">
                We are a reliable and experienced solar company that offers
                affordable and sustainable energy solutions, customized to fit
                your unique needs.
              </div>
              <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/254c7aaf89448159b472991e7628c18e5b5df4d89a95afc9d3b4c404d6e76313?"
                className="mt-7 max-w-full aspect-[4.35] w-[104px]"
              />
            </div>
          </div>
          <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
            <div className="mt-1 max-md:mt-10">
              <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                <div className="flex flex-col w-[46%] max-md:ml-0 max-md:w-full">
                  <div className="flex flex-col grow py-1 text-base text-neutral-600 max-md:mt-10">
                    <div className="text-xl font-semibold text-stone-900">
                      Links
                    </div>
                    <div className="mt-6">Home</div>
                    <div className="mt-2">Commercial Solar</div>
                    <div className="mt-2 max-md:mr-2.5">Residential Solar</div>
                    <div className="mt-2">Contact Us</div>
                  </div>
                </div>
                <div className="flex flex-col ml-5 w-[54%] max-md:ml-0 max-md:w-full">
                  <div className="flex flex-col grow py-0.5 text-base text-neutral-600 max-md:mt-10">
                    <div className="text-xl font-semibold text-stone-900">
                      Services
                    </div>
                    <div className="mt-6">Solar System Design</div>
                    <div className="mt-2">Procurement</div>
                    <div className="mt-2">Solar Panel Installations</div>
                    <div className="mt-2">Operations and Maintenance</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="shrink-0 self-stretch mt-6 w-full h-px border border-solid bg-neutral-200 border-neutral-200 max-md:mt-10 max-md:mr-1" />
      <div className="mt-6 text-sm text-center text-neutral-600">
        Copyright © 2023 All right policy reserved
      </div>
    </div>
  );
}

export default Footer;
